import React, { PropsWithChildren } from 'react'
import { Modal as MuiModal } from '@mui/base/Modal'
import clsx from 'clsx'
import classes from './Modal.module.scss'
import Button from '@/components/ui/Buttons/Button'

export type ModalProps = PropsWithChildren<{
  isOpen: boolean
  onClose: (data: any) => void
}>
const Modal = ({ children, isOpen, onClose }: ModalProps) => {
  return (
    <MuiModal
      className={classes.modal}
      slots={{ backdrop: Backdrop }}
      open={isOpen}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
    >
      <div className={classes.body}>{children}</div>
    </MuiModal>
  )
}

const Header = ({ children }: PropsWithChildren<object>) => <div className={classes.header}>{children}</div>

const Footer = ({ children }: PropsWithChildren<object>) => <div className={classes.footer}>{children}</div>

const Icon = ({ children }: PropsWithChildren<object>) => <div className={classes.icon}>{children}</div>

const Content = ({ children }: PropsWithChildren<object>) => <div className={classes.content}>{children}</div>

const Close = ({ onClick }: { onClick: (data: any) => void }) => (
  <Button variant={'outlined'} color={'neutral'} onClick={onClick}>
    Close
  </Button>
)

const Backdrop = React.forwardRef<HTMLDivElement, { open?: boolean; className: string }>(function Backdrop(props, ref) {
  const { open, className, ...other } = props
  return <div className={clsx({ 'MuiBackdrop-open': open }, classes.backdrop, className)} ref={ref} {...other} />
})

Modal.Header = Header
Modal.Footer = Footer
Modal.Icon = Icon
Modal.Content = Content
Modal.Close = Close

export default Modal
